<template>
  <validation-observer v-slot="{ handleSubmit, changed }" ref="formValidator">
    <b-form role="form" @submit.prevent="handleSubmit(updateEmailAddress)">
      <base-input
        v-model="model.emailAddress"
        name="Email address"
        type="text"
        placeholder="you@example.com"
        :rules="{ required: true, email: true }"
        :debounce="300"
      ></base-input>
      <base-button block type="secondary" native-type="submit" :disabled="!changed">
        <span v-if="!isUpdating">Update email address</span>
        <span v-else>
          Please wait&hellip;
          <i class="fa fa-spin fa-spinner"></i>
        </span>
      </base-button>
    </b-form>
  </validation-observer>
</template>

<script>
export default {
  props: {
    emailAddress: {
      type: String,
      required: true,
      description: "User email address"
    }
  },
  data() {
    return {
      isUpdating: false,
      model: {
        emailAddress: null
      }
    };
  },
  created() {
    this.model.emailAddress = this.emailAddress;
  },
  methods: {
    updateEmailAddress: function() {
      this.isUpdating = true;

      this.axios
        .put(`/v1/users/me/email`, { address: this.model.emailAddress })
        .then(response => {
          this.isUpdating = false;
          if (response.data && response.data.address) {
            this.$notify({
              message: "Email address updated",
              timeout: 2000,
              icon: "fa fa-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });

            // emit email address updated event
            this.$emit("update-email", response.data);
          }
          return response;
        })
        .catch(error => {
          this.isUpdating = false;
          let errorMessage = "Error updating profile";
          this.$notify({
            message: errorMessage,
            timeout: 2000,
            icon: "fa fa-exclamation-triangle",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        });
    }
  }
};
</script>